<template>
    <goods-level :type="0"></goods-level>
</template>

<script>
    import GoodsLevel from '../goods/level.vue'

    export default {
        name: 'companyGoodsLevel',
        components: {
            GoodsLevel
        },
        data() {
            return {
            }
        },
        mounted() {
            
        },
        methods: {
        }
    }
</script>
